<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">بين الجحيم والإنسانية</h1>
<ol class="toc">
<li id="toc-li-2"><a href="#/text/ch002#أكرم-البرجس"><span dir="rtl">أكرم البرجس</span></a></li>
<li id="toc-li-3"><a href="#/text/ch003#الإهداء"><span dir="rtl">الإهداء</span></a></li>
<li id="toc-li-4"><a href="#/text/ch004#%D8%AD%D9%82%D9%88%D9%82-%D8%A7%D9%84%D9%86%D8%B4%D8%B1"><span dir="rtl">حقوق النشر</span>©</a></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?08cc975c